import { render, staticRenderFns } from "./TaskFolderListItem.vue?vue&type=template&id=6560eb16"
import script from "./TaskFolderListItem.vue?vue&type=script&lang=ts"
export * from "./TaskFolderListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6560eb16')) {
      api.createRecord('6560eb16', component.options)
    } else {
      api.reload('6560eb16', component.options)
    }
    module.hot.accept("./TaskFolderListItem.vue?vue&type=template&id=6560eb16", function () {
      api.rerender('6560eb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/TaskFolderListItem.vue"
export default component.exports